import React from "react";
import { NavLink } from "react-router-dom";

const MenuItem = ({
  onClick,
  children,
  path: sPath = null,
  label: sLabel = null,
  className: sClassName = "",
  onlyIcon: bOnlyIcon = false,
}) => {
  // Rediseño: ítems compactos; el activo se marca con fondo celeste suave
  const getClass = ({ isActive: bIsActive }) => {
    const bIsCurrent = bIsActive && sPath;
    const sClass = [
      "flex items-center gap-2.5 rounded-md text-sm transition-colors",
      bOnlyIcon ? "justify-center py-2" : "px-2.5 py-1.5",
      bIsCurrent
        ? "bg-primary-50 text-primary-700 font-medium dark:bg-gray-800 dark:text-primary-300"
        : "text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white",
      sClassName,
    ];
    return sClass.join(" ");
  };

  return (
    <li>
      <NavLink
        to={sPath || ""}
        end={sPath === "/"}
        title={bOnlyIcon ? sLabel : undefined}
        className={getClass}
        onClick={() => onClick && onClick()}
      >
        {
          <>
            {children}
            {!bOnlyIcon && <span className={"truncate " + (children ? "" : "ml-7")}>{sLabel}</span>}
          </>
        }
      </NavLink>
    </li>
  );
};

export default MenuItem;
